<div class="modal-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <article class="modal-content">
        <section class="modal-header">
            <h2>Create/Link Bid</h2>
            <div class="bar"></div>

            <button class="close-wrapper" (click)="close(undefined)" aria-label="Close modal">
                <div class="icon" [innerHTML]="closeIcon"></div>
            </button>
        </section>
        <section class="modal-body">
            <p>How would you like to link the Bid?</p>

            <div class="radioGroup">
                <label>
                    <input
                        type="radio"
                        name="estimateType"
                        [(ngModel)]="estimateType"
                        value="blank"
                        [checked]="!!canCreateBlankEstimate"
                        (click)="removeSelectedTemplate()"
                        (change)="onEstimateTypeChange()"
                        [disabled]="!canCreateBlankEstimate"
                    />
                    Create blank Bid
                </label>
                <label>
                    <input
                        type="radio"
                        name="estimateType"
                        [(ngModel)]="estimateType"
                        value="template"
                        (change)="onEstimateTypeChange()"
                    />
                    Create template-based Bid
                </label>
                <label>
                    <input
                        type="radio"
                        name="estimateType"
                        [(ngModel)]="estimateType"
                        value="linkToExisting"
                        (change)="onEstimateTypeChange()"
                    />
                    Link to existing Bid
                </label>
            </div>

            <div [hidden]="estimateType !== 'template'">
                <div class="wrapper">
                    <div class="label">
                        <span>Select Template</span>
                    </div>
                    <div class="editor">
                        <lib-generic-type-ahead-dropdown
                            [(selectedItem)]="selectedTemplate"
                            [placeholder]="isLoadingTemplates ? 'Loading...' : 'Select'"
                            (selectedItemChange)="onTemplateChange($event)"
                            [(text)]="searchText"
                            [source]="source"
                            (textChange)="onTemplateTextChanged()"
                            [config]="{
                                defaultText: 'Select',
                                itemDisplayKey: 'name',
                                openOnFocus: true,
                                itemTemplate: templatesItemTemplate
                            }"
                        >
                        </lib-generic-type-ahead-dropdown>
                    </div>
                </div>
            </div>

            @if (estimateType === 'linkToExisting') {
                <div class="wrapper">
                    <div class="label">
                        <span>BID</span>
                    </div>
                    <div class="editor">
                        <app-type-ahead-uuids
                            [(selectedUUID)]="selectedTemplateUUID"
                            placeholder="Select BID"
                            (selectedUUIDChange)="onTemplateUUIDsChange($event)"
                            [displaySelected]="true"
                        >
                        </app-type-ahead-uuids>
                    </div>
                </div>
            }
            @if (showCannotLinkMessage) {
                <lib-message-box [message]="message" [type]="messageType"></lib-message-box>
            }
        </section>

        <section class="modal-footer">
            <button class="modal-button cancel" (click)="close(undefined)" [disabled]="isLoading">Cancel</button>
            <app-loading-button
                [isLoading]="isLoading"
                [disabled]="disabled"
                (clickEvent)="onConfirm()"
                [text]="estimateType === 'linkToExisting' ? 'Link' : 'Create'"
            ></app-loading-button>
        </section>
    </article>
</div>

<ng-template #templatesItemTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="data.object?.name ?? ''"
        [subtitle]="data.object?.projectDescription ?? ''"
    >
    </app-custom-menu-item>
</ng-template>
